<template>
  <div class="row">
    <div class="col-12">
      <ClientPaymentsCard :client="client" @reload="reload" />
    </div>
  </div>
</template>

<script>
import ClientPaymentsCard from "@/components/client/ClientPaymentsCard";

export default {
  components: {
    ClientPaymentsCard,
  },

  props: {
    client: {
      type: Object,
      required: true,
    },
  },

  methods: {
    reload() {
      this.$emit("reload");
    },
  },
};
</script>
